<template lang="pug">
div
  hq-panel-payment-method
  hq-self-pay-payment-method
</template>

<script>
import HqPanelPaymentMethod from '@/components/hq/inventory/HqPanelPaymentMethod.vue'
import HqSelfPayPaymentMethod from '@/components/hq/inventory/HqSelfPayPaymentMethod.vue'

export default {
  components: { HqPanelPaymentMethod, HqSelfPayPaymentMethod }
}
</script>
